export default __webpack_public_path__ + "static/sme-853df7d73e78ec2bac931fc92d48dcc2.jpg";